<template>
    <div class="container mx-auto px-2 py-8">
        <h1>Account</h1>
    </div>
    <div class="bg-body-color">
        <div class="container px-2 mx-auto py-12">
            <div class="w-full mb-4 text-xl font-plus-sans-bold">
                {{ userName }}
            </div>
            <div class="-mx-4 block md:flex">
                <div class="w-full md:w-1/4 px-4">
                    <SideMenu :links="links" class="box"/>
                </div>
                <div class="w-full md:w-3/4 px-4">
                    <div class="box">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useStore} from "vuex";
import {computed, reactive, ref, onMounted, watch} from 'vue';


export default {
    setup() {
        const store = useStore();
        const userName = ref('');
        const links = reactive([
            {
                name: 'Persönliche Daten',
                to: '/account'
            },
            {
                name: 'Projekte',
                to: '/projects'
            },
            {
                name: 'E-Mail ändern',
                to: '/edit-email'
            },
            {
                name: 'Passwort ändern',
                to: '/edit-password'
            },
            {
                name: 'Login',
                to: '/login'
            }
        ])
        const userData = computed(() => store.getters['Customer/userData']);

        onMounted(() => {
            userName.value = userData.value.surname + ' ' + userData.value.name

        })

        watch(userData, (selection, prevSelection) => {
            console.log('watch userData',userData.value)
            userName.value = userData.value.surname + ' ' + userData.value.name
        })

        return {
            userData,
            links,
            userName
        }
    }
}
</script>
